import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractComponent} from "../../abstract.component";
import {
  GroupScoringConfiguration, Lookups,
} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {required} from "@utility";

@Component({
  selector: 'app-group-scoring-config-edit-modal',
  templateUrl: './group-scoring-config-edit-modal.component.html',
  styleUrl: './group-scoring-config-edit-modal.component.scss',
  standalone: false
})
export class GroupScoringConfigEditModalComponent  extends AbstractComponent {
  @Input() scoringConfiguration: GroupScoringConfiguration | undefined;
  @Output() onSave: EventEmitter<GroupScoringConfiguration> = new EventEmitter<GroupScoringConfiguration>();
  @Input() scoringMethods: Lookups[] = []
  @Input() scoringDefinitions: Lookups[] = []
  @Input() disableEditing: boolean = true;
  @Input() groupScoringTypes: Lookups[] = [];


  constructor(public translocoService: TranslocoService,
              public activeModal: NgbActiveModal,
              public formBuilder: FormBuilder,
  ) {
    super();
  }

  inputForm = new FormGroup({
    name: new FormControl(),
    scoringDefinition: new FormControl(),
    registrationDeadline: new FormControl(),
    raceChangeDeadline: new FormControl(),
    groupScoringType: new FormControl(),
    maxScoringRounds: new FormControl(),
    maxTeamMembers: new FormControl(),
    genderSplitMaxMembers: new FormControl(),
    maxScoringMembers: new FormControl(),
    maxMaleScoringMembers: new FormControl(),
    maxFemaleScoringMembers: new FormControl(),
    minTeamFinishers: new FormControl(),
    genderSplitMinMembers: new FormControl(),
    minMaleFinishers: new FormControl(),
    minFemaleFinishers: new FormControl(),
    finishedBonusPoints: new FormControl(),
  });

  ngOnInit() {
    this.initForm()
    if (this.disableEditing) {
      this.inputForm.disable();
    }
  }

  initForm() {
    this.inputForm.controls.name.addValidators([required]);
    this.inputForm.controls.scoringDefinition.addValidators([required]);
    this.inputForm.controls.groupScoringType.addValidators([required]);
    this.inputForm.controls.maxScoringRounds.addValidators([required]);
    this.inputForm.controls.maxTeamMembers.addValidators([required]);
    this.inputForm.controls.genderSplitMaxMembers.addValidators([required]);
    this.inputForm.controls.genderSplitMinMembers.addValidators([required]);
    this.inputForm.controls.minTeamFinishers.addValidators([required]);
    this.inputForm.controls.finishedBonusPoints.addValidators([required]);

    this.subscriptions.push(this.inputForm.controls.genderSplitMaxMembers.valueChanges.subscribe(value => {
      if (value) {
        this.enableField(this.inputForm.controls.maxMaleScoringMembers, true);
        this.enableField(this.inputForm.controls.maxFemaleScoringMembers, true);
        this.disableField(this.inputForm.controls.maxScoringMembers)
      }
      else {
        this.disableField(this.inputForm.controls.maxMaleScoringMembers);
        this.disableField(this.inputForm.controls.maxFemaleScoringMembers);
        this.enableField(this.inputForm.controls.maxScoringMembers, true)
      }
    }))
    this.subscriptions.push(this.inputForm.controls.genderSplitMinMembers.valueChanges.subscribe(value => {
      if (value) {
        this.enableField(this.inputForm.controls.minFemaleFinishers, true);
        this.enableField(this.inputForm.controls.minMaleFinishers, true);
      }
      else {
        this.disableField(this.inputForm.controls.minFemaleFinishers);
        this.disableField(this.inputForm.controls.minMaleFinishers);
      }
    }))
    if (this.scoringConfiguration) {
      this.inputForm.patchValue(this.scoringConfiguration);
      this.inputForm.controls.scoringDefinition.setValue(this.scoringConfiguration.scoringDefinition?.id);
    }
    else {
      this.inputForm.controls.genderSplitMinMembers.setValue(false);
      this.inputForm.controls.genderSplitMaxMembers.setValue(false);
    }
  }

  onClose(): void {
    this.activeModal.dismiss();
  }

  onSaveButtonClick(): void {
    if (!this.inputForm.valid) {
      this.markAllAsTouched(this.inputForm);
    }
    else {
      let config : GroupScoringConfiguration = {...this.scoringConfiguration};
      config.name = this.inputForm.controls.name.value;
      const scoringDefinitionId = this.inputForm.controls.scoringDefinition.value;
      const scoringDefinition = this.scoringDefinitions.find(
          definition => definition.id === scoringDefinitionId
      );

      config.scoringDefinition = scoringDefinition;
      config.registrationDeadline = this.inputForm.controls.registrationDeadline.value;
      config.raceChangeDeadline = this.inputForm.controls.raceChangeDeadline.value;
      config.groupScoringType = this.inputForm.controls.groupScoringType.value;
      config.maxScoringRounds = this.inputForm.controls.maxScoringRounds.value;
      config.maxTeamMembers = this.inputForm.controls.maxTeamMembers.value;
      config.genderSplitMaxMembers = this.inputForm.controls.genderSplitMaxMembers.value;
      config.maxScoringMembers = this.inputForm.controls.maxScoringMembers.value;
      config.maxMaleScoringMembers = this.inputForm.controls.maxMaleScoringMembers.value;
      config.maxFemaleScoringMembers = this.inputForm.controls.maxFemaleScoringMembers.value;
      config.minTeamFinishers = this.inputForm.controls.minTeamFinishers.value;
      config.genderSplitMinMembers = this.inputForm.controls.genderSplitMinMembers.value;
      config.minMaleFinishers = this.inputForm.controls.minMaleFinishers.value;
      config.minFemaleFinishers = this.inputForm.controls.minFemaleFinishers.value;
      config.finishedBonusPoints = this.inputForm.controls.finishedBonusPoints.value;
      this.onSave.emit(config);
    }
  }

}
